module.exports = __webpack_public_path__ + "6f860eaa05000eda98f0e126a3a58563.fbx";